// Don't interact with the state directly. Actions use mutation to change the state.
// Actions carry out asynchronous operations
import { roomsCollection } from "@/firebase";
import { generateDices } from "@/utils/dices";

const moduleActions = {
  fetchRooms({ commit }) {
    roomsCollection.onSnapshot(snapshot => {
      const rooms = {};

      snapshot.forEach(doc => {
        rooms[doc.id] = doc.data();
        rooms[doc.id].id = doc.id;
      });

      commit("setRooms", { rooms });
    });
  },
  createRoom({ state }, room) {
    console.log("createRoom", state); // eslint-disable-line
    const dices = generateDices(parseInt(room.nbDices));
    roomsCollection
      .add({
        name: room.name,
        nbDices: parseInt(room.nbDices),
        dices: dices,
        timestamp: Date.now()
      })
      .then(ref => {
        this.dispatch("events/pushEvent", {
          roomId: ref.id,
          type: "initialize",
          data: dices
        });
      });
  },
  updateRoom({ state }, { roomId, data }) {
    const room = state.rooms[roomId];

    roomsCollection.doc(roomId).update({
      name: room.name,
      nbDices: room.nbDices,
      dices: data,
      timestamp: room.timestamp
    });
  }
};

export default moduleActions;
